<template>
    <article class="message-user" aria-label="Your message">
        <AttachmentList v-if="message.attachments?.length" :attachments="message.attachments" />
        <v-card v-if="message.text" class="message-user-bubble" rounded="xl" elevation="0">
            <p>{{ message.text }}</p>
        </v-card>
    </article>
</template>

<script>
import AttachmentList from '../attachments/AttachmentList.vue'

export default {
    name: 'MessageUser',
    components: { AttachmentList },
    props: {
        message: { type: Object, required: true }
    }
}
</script>

<style scoped>
.message-user {
    align-self: flex-end;
    max-width: 80%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 12px;
}

.message-user :deep(.attachment-list) {
    justify-content: flex-end;
}

.message-user-bubble {
    animation: agent-message-in var(--agent-motion-duration, 300ms) var(--agent-motion-easing, ease-out);
    max-width: 100%;
    padding: 16px 20px;
    border-bottom-right-radius: 6px !important;
    background: rgba(var(--v-theme-color1), 0.1);
    border: 1px solid rgba(var(--v-theme-color1), 0.15);
    color: rgb(var(--v-theme-primary));
}

p {
    margin: 0;
    text-align: right;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    font-size: 15px;
    line-height: 1.65;
}

@media (max-width: 600px) {
    .message-user {
        max-width: 90%;
    }
}
</style>
